export default function IconPlay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width || "35"}
      height={props.height || "35"}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17" fill="black" stroke="black" />
      <path
        d="M24.6043 16.1468C25.2422 16.5367 25.2422 17.4632 24.6043 17.8532L14.7716 23.8641C14.1052 24.2714 13.25 23.7919 13.25 23.0109L13.25 10.9891C13.25 10.2081 14.1052 9.72858 14.7716 10.1359L24.6043 16.1468Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
}
